/**
 * external libs
 */
import React, {useMemo, useState, useEffect, useContext} from 'react'
import {useHistory, useParams} from "react-router-dom";
import {Link} from 'react-router-dom'
import {Tooltip} from 'antd'
/**
 * components
 */
import Table from "../../../../components/Table";
import Loader from "../../../../components/Loader";
import CardMembersList from "../../../../components/CardMembersList";
/**
 * enums
 */
import ResultTypeMemberIdEnum from "../../../../enums/api/ResultTypeMemberIdEnum";
import DimensionIdEnum from "../../../../enums/api/DimensionId";
import PaginationBtn from "../../../../pages/web/pages/MedicalCardList/components/PaginationBtn";
import AvatarItem from "../../../../components/TableComponents/MedicalCard/components/AvatarItem";
import UserItem from "../../../../components/TableComponents/MedicalCard/components/UserItem";
import GenderItem from "../../../../components/TableComponents/MedicalCard/components/GenderItem";
import styles from './index.module.scss'
import PickerTypeEnum from "../../../../enums/PickerType";
import {MEDICAL_CARDS_MAKE_PAGE_URI} from "../../../../constants/uri.constant";
import FolderIdEnum from "../../../../enums/api/FolderId";
import excludeMembersUtil from "../../../../utils/exludeMembers";
import {GlobalFolderContext} from "../../../../pages/context/globalFolder.context";
export default function CardsTable({medicalCard, cardFolderId, getSelectedCard, closePaginate, setClosePaginate, pickerType, excludeMembers = [], getMedicalCard, isReadyPagination, isReady, perPage}) {
    const history = useHistory();
    const [selectedCard, setSelectedCard] = useState(!medicalCard[0]?.id || (medicalCard.length === 1) ? [medicalCard[0]?.id] : [])
    const columns = useMemo(() => ([
        ...( pickerType ? [{
            title: "",
            dataIndex: 'picked',
            key: 'picked',
            fixed: 'left',
            width: 0,
            render: (_, medCard) => {
                if(pickerType === PickerTypeEnum.radio){
                    return (
                        <div className={styles.radio}>
                            {selectedCard.includes(medCard?.id) && (
                                <div className={styles.radio__pick}/>
                            )}
                        </div>
                    )
                }
                if(pickerType === PickerTypeEnum.checkbox){
                    return (
                        <div className={styles.checkbox}>
                            {selectedCard.includes(medCard?.id) && (
                                <div className={styles.checkbox__pick}/>
                            )}
                        </div>
                    )
                }


                return null
            },
        }] : []),
        {
            title: "",
            dataIndex: 'avatar',
            key: 'avatar',
            fixed: 'left',
            render: (_, medCard) => {
                const firstNameMeasures = medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.firstName);
                const lastNameMeasures = medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.lastName);
                return (
                    <div style={{whiteSpace: "nowrap"}}>
                        <AvatarItem
                            avatarResult={medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.photo)}
                            firstName={firstNameMeasures}
                            lastName={lastNameMeasures}
                        />
                    </div>
                );
            },
        },
        {
            title: "",
            dataIndex: 'name',
            key: 'name',
            render: (_, medCard) => {
                return (
                    <div style={{whiteSpace: "nowrap"}}>
                        {medCard.id ? (
                            <UserItem
                                firstNameResult={medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.firstName)}
                                lastNameResult={medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.lastName)}
                                middleNameResult={medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.middleName)}
                                avatarResult={medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.photo)}
                                copy={false}
                            />
                        ): "New card"}
                    </div>
                )
            },
        },
        {
            title: "",
            dataIndex: 'birthday',
            key: 'birthday',
            render: (_, medCard) => {
                return (
                    <GenderItem
                        birthDayResult={medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.birthDay)}
                        deathDayResult={medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.deathDay)}
                        genderResult={medCard.getResultFromCardByMemberId(ResultTypeMemberIdEnum.sex)}/>
                )
            }
        },
        {
            title: "",
            dataIndex: 'card_member',
            key: 'card_member',
            render: (_, medCard) => {
                return (
                    <CardMembersList cardMembers={[...(medCard.member || [])]}
                                     excludeMembers={[...excludeMembers]}
                                     excludeDimensions={[DimensionIdEnum.sex]}/>
                )
            }
        },
        {
            title: "",
            dataIndex: 'member',
            key: 'member',
            render: (_, medCard) => {
                return medCard.holders.map( (holder, index) => (
                    <div style={{marginTop: !index ? 0 : 8}}>
                        <CardMembersList excludeDimensions={[DimensionIdEnum.sex]}
                                         excludeMembers={[...excludeMembers]}
                                         cardMembers={holder?.member || []}/>
                    </div>
                ))
            }
        },
    ]), [selectedCard, excludeMembers]);


    useEffect(() => {
        getSelectedCard(selectedCard)
    }, [selectedCard])

    if (!isReady) {
        return (
            <div style={{marginTop: 30}}>
                <Loader width={150}/>
            </div>
        )
    }


    return (
        <div>
            <div style={{maxHeight: `60vh`, overflow: "auto"}}>
                <Table data={medicalCard ? medicalCard.filter((_, index) => closePaginate || (index < (medicalCard.length - 1))) : []}
                       pagination={false}
                       columns={columns}
                       loading={!isReady}
                       fetchingData={getMedicalCard}
                       onRow={(medCard) => ({
                           onClick: () => {
                               if(pickerType === PickerTypeEnum.radio){
                                   setSelectedCard([medCard.id])
                                   return;
                               }

                               if(pickerType === PickerTypeEnum.checkbox){
                                   setSelectedCard(selectedCard => {
                                       if(selectedCard.includes(medCard.id)){
                                           return selectedCard.filter( cardId => cardId !== medCard.id)
                                       }

                                       return [...selectedCard, medCard.id]
                                   })
                               }


                               return history.push(MEDICAL_CARDS_MAKE_PAGE_URI(cardFolderId, medCard.id, FolderIdEnum.contacts))
                           },
                           style: { cursor: 'pointer' },
                       })}
                />
                <PaginationBtn medicalCard={medicalCard} closePaginate={closePaginate} setClosePaginate={setClosePaginate} isReady={isReadyPagination} getMedicalCard={getMedicalCard} perPage={perPage}/>
            </div>
        </div>
    )
}
